
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plik-dek",
      function () {
        return require("private-next-pages/plik-dek/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plik-dek"])
      });
    }
  